<template>
	<vs-popup
		:active.sync="activeProp"
		:title="$t('siteChatResponseDialogTitile')"
	>
		<div class="dlgEditAnswerBody" >
			<div>{{ $t('siteAutoEmailName') }}</div>
			<vs-input
                :readonly="true"
                v-model="websiteAnswer.templateName"
                class="w-full"
            />
            <br>
			<div>{{ $t('siteAutoEmailParameter') }}</div>
			<vs-textarea
				v-model="websiteAnswer.templateParameter"
                :readonly="true"
                class="w-full text-sm"
				rows="1"
			/>
            <br>
			<div>{{ $t('siteAutoEmailTemplate') }}</div>

			<vue-editor v-model="websiteAnswer.templateTemplate" />

			<div class="vx-row m-5">
				<div class="vx-col w-full">
					<label class="site-invoice-info__label"><b>{{ $t('addPresentationPdf') }}</b></label><br>
					<label class="w-full site-invoice-info__label text-xs font-medium">{{ $t('presentationPdfNameHref') }}</label>
					<vs-input
						v-model="websiteAnswer.presentationPdfNameHref"
						class="w-full text-xs font-medium"
					/>
					<div class="logo-block__logo m-3">
						<div
							v-if="(!websiteAnswer.templatePresentationPdf || isEditingPresentationPdf2) && $store.state.auth.role === 'admin'"
							class="logo-block__upload p-3"
						>
							<PdfUpload
								:text="$t('loadFile')"
								@change="changePresentationPdf"
							/>
						</div>
						<div v-else >
							<a :href="websiteAnswer.templatePresentationPdf" target="_blank">{{ websiteAnswer.templatePresentationPdf }}</a>
						</div>
					</div>
					<div class="logo-block__controls vx-row">
						<div class="vx-col w-1/2">
							<vs-custom-button
								v-if="$store.state.auth.role === 'admin'"
								:disabled="!websiteAnswer.templatePresentationPdf"
								@click="isEditingPresentationPdf2 = !isEditingPresentationPdf2"
								class="logo-block__btn w-full pl-1 pr-1 text-xs font-medium text-center"
							>
								{{ changePresentationPdfBtnText2 }}
							</vs-custom-button>
						</div>

						<div class="vx-col w-1/2">
							<vs-custom-button
								v-if="$store.state.auth.role === 'admin'"
								:disabled="!websiteAnswer.templatePresentationPdf"
								@click="websiteAnswer.templatePresentationPdf = ''"
								type="border"
								color="danger"
								class="logo-block__btn w-full pl-1 pr-1 text-xs font-medium text-center"
							>{{ $t('deletePresentationPdf') }}</vs-custom-button>
						</div>
					</div>
				</div>
			</div>
		</div>
        <div class="set-ticket-done__controls">
			<vs-button
				v-if="$store.state.auth.role === 'admin'"
				@click="confirm"
				color="primary"
			>{{ $t('save') }}</vs-button>
    
			<vs-button
				@click="close"
				color="#9a9a9a"
				type="flat"
			>{{ $t('cancel') }}</vs-button>
		</div>
	</vs-popup>
</template>

<script>
import { VueEditor } from "vue2-editor";
import PdfUpload from "@/components/PdfUpload";
import notifier from "@/mixins/notifier";
import databaseManager from "@/mixins/databaseManager";

export default {
	name: "EditSiteChatResponseTemplate",
	props: {
		active: {
			required: true,
			type: Boolean
		},
		websiteAnswer: {
			required: true,
		},
	},
	data() {
		return {
			isEditingPresentationPdf2: false,
		}
	},
	mixins: [databaseManager, notifier],
    components: {
        VueEditor,
		PdfUpload,
    },
    watch: { 
		activeProp(newValue) {
			if(newValue === false) {
				this.reward = 0;
			}
		}
	},
	computed: {
		changePresentationPdfBtnText2() {
			return this.isEditingPresentationPdf2 ? this.$t('cancel') : this.$t('changePresentationPdf');
		},
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},
	methods: {
		confirm() {
			if(this.websiteAnswer === null) return;

			this.$emit("confirm", this.websiteAnswer);
			this.activeProp = false;
		},
        close() {
			this.activeProp = false;
		},
		async changePresentationPdf(path, files) {
			try {
				const data = [files[files.length - 1]];
				const res = await this.dbUploadMany(data);
				this.websiteAnswer.templatePresentationPdf = res[0].url;
				this.isEditingPresentationPdf2 = false;

			} catch(e) {
				this.notifyError(e.message);
			}
		},
	},
};
</script>

<style scoped lang="scss">
.site-invoice-info {
	&__label {
		font-size: 0.85rem;
		margin-left: 5px;
		color: rgba(0, 0, 0, 0.7);
	}

	& .logo-block {
		margin-top: 20px;
	}

	.logo-block {
		flex: 320px 1 0;

		&__container {
			width: 100%;
			max-width: 320px;
		}

		&__upload {
			width: 100%;
			height: 100%;
		}

		&__controls {
			display: flex;
		}

		&__btn {
			margin-top: 15px
		}

		&__logo {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 140px;
			background-color: #eeeeee;
			border-radius: 10px;
			overflow: hidden;
		}

		&__img {
			max-width: 100%;
			max-height: 100%;
		}
	}

	& > .vx-row > .vx-col {
		margin-top: 25px;
	}

	@media screen and (max-width: 768px) {
		& > .vx-row > .vx-col {
			&:first-child {
				margin-top: 0;
				margin-bottom: 16px;
			}
		}

		& .logo-block {
			margin-top: 0;
		}
	}
}
</style>